import { withAuthenticationRequired } from '@auth0/auth0-react'
import { Route, Routes } from 'react-router'
import { ModalPage } from '../../components/layout'
import { CreateAppointmentNew } from './New'
import { CreateAppointmentSuccess } from './Success'
import { NotFound } from 'modules/NotFound'

const CreateAppointmentRoutes = () => {
  return (
    <ModalPage>
      <Routes>
        <Route element={<CreateAppointmentNew />} path="/" />
        <Route element={<CreateAppointmentSuccess />} path="success" />
        <Route element={<NotFound />} path="*" />
      </Routes>
    </ModalPage>
  )
}

const CreateAppointment = withAuthenticationRequired(CreateAppointmentRoutes)

export { CreateAppointment }
